import { Injectable, inject } from '@angular/core';
import { StorageService } from '../../../core/services/global/storage.service';
import { AccountService } from './account.service';
import { Account } from '../../models';
import { TrialMilestone } from '../../models/plan/trial-milestone';
import { TRIAL_POPUP_DAYS, TRIAL_TOTAL_DAYS } from './plan-state.constants';
import { PlanState } from '../../enums/plan-state.enum';

@Injectable({ providedIn: 'root' })
export class TrialPopupService {
  private readonly storage = inject(StorageService);
  private readonly accountService = inject(AccountService);

  getDueMilestone(account: Account): TrialMilestone | null {
    const state = this.accountService.getPlanState(account);

    if (state === PlanState.Limited) {
      // A never-trialed Limited account (fresh registration, no `trialEnd`)
      // must not get the "trial has ended" popup.
      return this.accountService.hadTrial(account) ? this.dueIfUnshown('end') : null;
    }

    if (state === PlanState.Trial) {
      const milestone = this.trialMilestoneForDaysLeft(this.accountService.trialDaysLeft(account));
      return milestone ? this.dueIfUnshown(milestone) : null;
    }

    return null;
  }

  markShown(milestone: TrialMilestone): void {
    const shown = this.storage.getTrialPopupShown();
    this.storage.setTrialPopupShown({ ...shown, [milestone]: true });
  }

  private trialMilestoneForDaysLeft(daysLeft: number): TrialMilestone | null {
    if (daysLeft <= TRIAL_TOTAL_DAYS - TRIAL_POPUP_DAYS.SECOND) {
      return 'day9';
    }
    if (daysLeft <= TRIAL_TOTAL_DAYS - TRIAL_POPUP_DAYS.FIRST) {
      return 'day7';
    }
    return null;
  }

  private dueIfUnshown(milestone: TrialMilestone): TrialMilestone | null {
    return this.wasShown(milestone) ? null : milestone;
  }

  private wasShown(milestone: TrialMilestone): boolean {
    return this.storage.getTrialPopupShown()[milestone] === true;
  }
}
